import get from "lodash/get";
import customSort from "../../../../helpers/sortByProp";

const REFINEMENT_SEPARATOR = "|";
const PRICE_SEPARATOR = "<";
const ID_VALUES_SEPARATOR = ":";

const getQuery = state => get(state, "search.query", { query: {} });

const getFacets = state => get(state, "search.facets", []);

const getFacetName = (state, facetId) =>
  (getFacets(state).find(({ id }) => id === facetId) || {}).name;

const alphabetically = customSort(refinement => refinement.refinementId);

const getPriceMinMax = refinementValues => {
  const [min, max] = refinementValues.split(PRICE_SEPARATOR);

  return {
    min: Number(min),
    max: Number(max)
  };
};

const getRefinementFromQuery = query => {
  const [refinementId, refinementValues] = query.split(ID_VALUES_SEPARATOR);

  return {
    refinementId,
    refinementValues
  };
};

const buildRefinements = (state, refine) =>
  refine.split(REFINEMENT_SEPARATOR).reduce((refinements, refinementQuery) => {
    const { refinementId, refinementValues } = getRefinementFromQuery(
      refinementQuery
    );

    const createDefaultRefinement = () => ({
      refinementId,
      refinementName: getFacetName(state, refinementId)
    });

    const createPrice = () => ({
      ...createDefaultRefinement(),
      ...getPriceMinMax(refinementValues)
    });

    const createRefinement = () => {
      switch (refinementId) {
        case "currentprice":
          return createPrice();
        default:
          return createDefaultRefinement();
      }
    };

    return refinementId ? refinements.concat(createRefinement()) : refinements;
  }, []);

const buildSort = () => [{ refinementId: "sort", refinementName: "sort" }];

const getAllAppliedRefinements = state => {
  const { sort, refine = "" } = getQuery(state);
  const refinements = buildRefinements(state, refine).sort(alphabetically);

  return sort ? refinements.concat(buildSort()) : refinements;
};

export { getAllAppliedRefinements as default };
